import api from './api';
import { ArchiveItem, PaginatedResponse } from '../types';

export type ArchiveType = 'DOCUMENT' | 'PHOTO' | 'VIDEO' | 'AUDIO' | 'NEWSPAPER' | 'OTHER';

interface ArchiveFilters {
  type?: ArchiveType;
  category?: string;
  year?: number;
  search?: string;
  isPublic?: boolean;
  page?: number;
  limit?: number;
}

export const archiveService = {
  async getList(filters: ArchiveFilters = {}): Promise<PaginatedResponse<ArchiveItem>> {
    const params = new URLSearchParams();
    
    if (filters.type) params.append('type', filters.type);
    if (filters.category) params.append('category', filters.category);
    if (filters.year) params.append('year', filters.year.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.isPublic !== undefined) params.append('isPublic', filters.isPublic.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<ArchiveItem>>('/archive', { params });
    return response.data;
  },

  async getById(id: number): Promise<ArchiveItem> {
    const response = await api.get<ArchiveItem>(`/archive/${id}`);
    return response.data;
  },

  async create(data: Omit<ArchiveItem, 'id' | 'createdAt' | 'updatedAt'>): Promise<ArchiveItem> {
    const response = await api.post<ArchiveItem>('/archive', data);
    return response.data;
  },

  async update(id: number, data: Partial<ArchiveItem>): Promise<ArchiveItem> {
    const response = await api.put<ArchiveItem>(`/archive/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/archive/${id}`);
  },

  async togglePublic(id: number): Promise<ArchiveItem> {
    const response = await api.post<ArchiveItem>(`/archive/${id}/toggle-public`);
    return response.data;
  },
};
